import { Component, Input, Output, EventEmitter, ViewChild, DoCheck } from '@angular/core';
@Component({
  selector: 'app-capacity-chart',
  templateUrl: './capacityChart.component.html'
})
export class CapacityChartComponent implements DoCheck {
  @ViewChild('LastChart') LastChart: any;
  @Input() xAchsenBeschriftung = 'R (m)';
  @Input() yAchsenBeschriftung = 'cap (t)';
  @Input() toolTipFormat = 'Radius: #point.x#<br />Capacity: #point.y#';
  @Output('serienSichtbarkeit') serienSichtbarkeit: EventEmitter<string[]> = new EventEmitter();
  public commonSeriesOptions: Object;
  private oldToolTip = '';
  constructor() {
  }

  ngDoCheck() {
    if (this.oldToolTip !== this.toolTipFormat) {
      this.oldToolTip = this.toolTipFormat;
      this.commonSeriesOptions = {
        type: 'line',
        enableAnimation: true,
        tooltip: {
          visible: true,
          format: this.toolTipFormat
        },
        marker: {
          visible: true,
          size: { height: 7, width: 7 },
          shape: 'circle'
        },
        border: { color: 'black', width: 2 }
      };
    }
  }
  getVisibilityOfSeries(event) {
    setTimeout(() => {
      this.serienSichtbarkeit.emit([
        this.LastChart.widget.model.series[0].visibility,
        this.LastChart.widget.model.series[1].visibility,
        this.LastChart.widget.model.series[2].visibility,
        this.LastChart.widget.model.series[3].visibility
      ]);
    }, 10);
  }
}
